<template>
  <div
    id="form-search-popover"
    class="component-card container-app-search">
    <j-title-header :options="title"/>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="openCreateModal">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <!-- <b-button
            class="btn grey btn-import-form m__r--5"
            @click="exportData">
            <i class="fa fa-download fa-lg"/> Export
          </b-button> -->

          <b-form
            inline
            @keypress.13.prevent="filter()">
            <j-select
              v-model="select_type"
              :options="options_search"
              placeholder="Filter By"
              class="m__r--5"/>
            <b-form-input
              v-model="filter_data"
              placeholder="Search"
              style="width: 250px !important; height: 33px;"/>
          </b-form>
        </b-form>
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-modal
      ref="modalPengumuman"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">
        {{ modeModal === 'create' ? 'Create Data' : 'Update Data' }}
      </h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_pengumuman.subject.$error}">
            <label> Subject </label>
            <j-input
              v-model="$v.data_pengumuman.subject.$model"
              :disabled="readOnly"
              placeholder="Subject"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_pengumuman.description.$error}">
            <label> Description </label>
            <quill-editor
              ref="myQuillEditor"
              v-model="data_pengumuman.description"
              :options="editorOption"
              :disabled="readOnly"
            />
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_pengumuman.start_date.$error}">
            <label> Start Date </label>
            <j-datepicker
              v-model="$v.data_pengumuman.start_date.$model"
              :disabled="readOnly"
              placeholder="Start Date"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_pengumuman.end_date.$error}">
            <label> End Date </label>
            <j-datepicker
              v-model="$v.data_pengumuman.end_date.$model"
              :disabled="readOnly"
              placeholder="End Date"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_pengumuman.active.$error}">
            <label> Is Active </label>
            <j-toggle
              v-model="$v.data_pengumuman.active.$model"
              :disabled="readOnly"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div
        v-if="modeModal === 'create'"
        class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
      <b-row v-else>
        <b-col md="3">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="9">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import he from 'he';
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiHubin from '@/services/jApiHubin';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  components: {
    jLoadingTable,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Data Pengumuman',
      },

      editorOption: {

      },
      data_pengumuman: {
        subject: '',
        description: '',
        start_date: null,
        end_date: null,
        active: false,
      },
      modeModal: 'create',
      filter_data: '',
      select_type: 'subject',
      options_search: [
        {
          text: 'Subject',
          value: 'subject',
        },
      ],
      load_first: false,
      data_table: [],
      columns: ['id', 'subject', 'start_date', 'end_date', 'active'],
      options: {
        headings: {
          id: 'ID',
          subject: 'SUBJECT',
          start_date: 'START DATE',
          end_date: 'END DATE',
          active: 'ACTIVE',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            subject: data.subject,
            limit: data.limit,
            page: data.page,
          };
        },
        requestFunction(data) {
          const getList = jApiHubin.getListPengumuman(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreHubin', ['createPengumuman', 'updatePengumuman', 'deletePengumuman', 'exportPengumuman']),

    loading(val) {
      const a = val;
      a.subject = this.filter_data;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    filter() {
      this.$refs.tableServer.getData();
    },

    openCreateModal() {
      this.$refs.modalPengumuman.show();
      this.modeModal = 'create';
    },

    closeModalCreate() {
      this.$refs.modalPengumuman.hide();
      this.data_pengumuman = {
        subject: '',
        description: '',
        start_date: null,
        end_date: null,
        active: false,
      };
      setTimeout(() => {
        this.$v.data_pengumuman.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalPengumuman.hide();
      this.data_pengumuman = {
        subject: '',
        description: '',
        start_date: null,
        end_date: null,
        active: false,
      };
      setTimeout(() => {
        this.$v.data_pengumuman.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.$refs.modalPengumuman.show();
      this.modeModal = 'update';
      this.data_pengumuman = {
        id: param.row.id,
        subject: param.row.subject,
        description: param.row.description ? he.decode(param.row.description) : '',
        start_date: param.row.start_date,
        end_date: param.row.end_date,
        active: param.row.active === '1',
      };
    },

    saveData() {
      this.$v.data_pengumuman.$touch();
      if (!this.$v.data_pengumuman.$error) {
        const params = this.data_pengumuman;
        params.description = params.description ? this.encodeHtmlEntities(params.description) : '';
        params.start_date = params.start_date ? this.$moment(params.start_date).format('YYYY-MM-DD HH:mm:ss') : '';
        params.end_date = params.end_date ? this.$moment(params.end_date).format('YYYY-MM-DD HH:mm:ss') : '';
        this.createPengumuman(params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalCreate();
            }, 1500);
          }
        });
      }
    },

    updateData() {
      this.$v.data_pengumuman.$touch();
      if (!this.$v.data_pengumuman.$error) {
        const params = this.data_pengumuman;
        params.description = params.description ? this.encodeHtmlEntities(params.description) : '';
        params.start_date = params.start_date ? this.$moment(params.start_date).format('YYYY-MM-DD HH:mm:ss') : '';
        params.end_date = params.end_date ? this.$moment(params.end_date).format('YYYY-MM-DD HH:mm:ss') : '';
        this.updatePengumuman(params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalUpdate();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_pengumuman.id,
          };
          this.deletePengumuman(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },

    encodeHtmlEntities(str) {
      return he.encode(str);
    },

    exportData() {
      const params = {
        subject: this.filter_data,
        limit: '10000000',
        page: '1',
      };
      this.exportPengumuman(params).then((res) => {
        window.location.href = res.data.data.url;
      });
    },
  },
  validations() {
    return {
      data_pengumuman: {
        subject: { required },
        description: { required },
        start_date: { required },
        end_date: { required },
        active: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/hubungan-dinas/pengumuman/jPengumumanList.vue